var React = require('react');

function StarInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.6733 0L8.20323 6.375H0.792969L6.96818 10.625L4.4981 17L10.6733 12.75L16.8485 17L14.3784 10.625L20.5537 6.375H13.1434L10.6733 0Z","fill":"#021546"}));
}

StarInline.defaultProps = {"width":"21","height":"17","viewBox":"0 0 21 17","fill":"none"};

module.exports = StarInline;

StarInline.default = StarInline;
